<template>
    <div
        class="manual-receiver-card gcmcn-card"
        :class="{'selected-element' : selectedManualReceiverUid === manualReceiver.uid}"
        @click="showManualReceiverDetails"
    >
        <div>
            <span class="manual-receiver-name">{{ manualReceiver.name }}</span>
            <div>{{ entityName }} | {{ takerName  }}</div>
        </div>
        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : selectedManualReceiverUid === manualReceiver.uid}"
        ></i>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {

    },

    props: {
        manualReceiver: {
            type: Object,
            required: true
        },
        selectedManualReceiverUid: {
            type: String,
            required: true
        },
    },

    data: function(){
        return {
        };
    },

    computed: {
        ...mapGetters([
            'takersByUid',
            'entitiesByUid'
        ]),
        takerName(){
            return this.takersByUid(this.manualReceiver.taker_uid).name;
        },
        entityName(){
            return this.entitiesByUid(this.manualReceiver.scopes.entity_uid).display_name;
        }
    },

    mounted: function(){
    },

    methods: {
        showManualReceiverDetails() {
            this.$emit('change-selected-manual-receiver', this.manualReceiver.uid);
        }
    },
};
</script>

<style lang="scss">
.manual-receiver-card {
    display: flex;
    position: relative;
    cursor: pointer;

    .manual-receiver-name{
        font-weight: bold;
    }


    +.manual-receiver-card {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Manual/manualReceiverCard.vue